import * as React from "react";
const SvgCloseIcon = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m6 6 12 12M18 6 6 18", stroke: "#4A4A4A", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgCloseIcon;
